import React from 'react';

import { useIntl } from 'react-intl';

import { ERROR_IMAGE_STORM_WITH_MEEPLES } from '../../ErrorResources';

import BasicError from './BasicError';

export default (): React.JSX.Element => {
	const intl = useIntl();

	const textItems = [
		intl.formatMessage({
			id: 'townsquare.error.network5xx.title',
			description: 'Heading shown on the 5xx network error page when a server-side error occurs.',
			defaultMessage: 'Something went wrong.',
		}),
		intl.formatMessage({
			id: 'townsquare.error.network5xx.description',
			description:
				'Body text shown on the 5xx network error page explaining that the error has been reported and prompting the user to try again.',
			defaultMessage: "We're working to restore your service.",
		}),
	];
	return <BasicError img={ERROR_IMAGE_STORM_WITH_MEEPLES} errorText={textItems} />;
};
